<div class="modal-body p-3">
  <div class="row">
    <div class="pagination-container" *ngIf="blobUrls.length > 1">
      <span>{{ 'common.associated-docs' | translate}}:</span>
      <button
        class="icon-btn"
        (click)="previous()"
        [disabled]="currentIndex === 0"
        aria-label="Previous"
      >
        «
      </button>
      <span class="page-indicator">
        {{ currentIndex + 1 }} / {{ blobUrls.length }}
      </span>
      <button
        class="icon-btn"
        (click)="next()"
        [disabled]="currentIndex === blobUrls.length - 1"
        aria-label="Next"
      >
        »
      </button>
    </div>
    <div style="width: 100%; height: 800px">
      <ng-container *ngIf="isViewerVisible">
        <ng2-pdfjs-viewer
          [pdfSrc]="tempBlobUrl"
          zoom="page-width"
          [downloadFileName]="currentFileName"
        ></ng2-pdfjs-viewer>
      </ng-container>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-12">
      <div class="btn-container">
        <div class="wallet-group">
          <button
            type="button"
            class="wallet-btn"
            (click)="addToGoogleWallet()"
            [disabled]="!bookedUuid || !bookedType || loadingWalletLink"
            [attr.aria-busy]="loadingWalletLink ? 'true' : null"
          >
            <img src="assets/img/svg/google-wallet.svg" />
          </button>

          <button
            type="button"
            class="wallet-btn"
            (click)="addToAppleWallet()"
            [disabled]="!bookedUuid || !bookedType || loadingAppleLink"
            [attr.aria-busy]="loadingAppleLink ? 'true' : null"
          >
            <img src="assets/img/svg/apple-wallet.svg" />
          </button>
        </div>

        <div class="action-btn-group">
          <button class="custom-btn download-btn" (click)="downloadPDFBooked()">
            {{ 'common.download' | translate }}
          </button>
          <button class="custom-btn custom-btn--close" (click)="closeModal()">
            {{ 'common.close' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
